module.exports = __webpack_public_path__ + "img/shot_bigtx20032001.0818bd20.png";